<!-- =========================================================================================
	File Name: ECommerceCheckout.vue
	Description: eCommerce Checkout page
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="ecommerce-checkout-demo">
    <form-wizard
      ref="checkoutWizard"
      color="rgba(var(--vs-primary), 1)"
      :title="null"
      :subtitle="null"
      :hide-buttons="true">

      <!-- tab 1 content -->
      <tab-content title="Cart" icon="feather icon-shopping-cart" class="mb-5">

        <!-- IF CART HAVE ITEMS -->
        <div class="vx-row" v-if="cartItems.length">

          <!-- LEFT COL -->
          <div class="vx-col lg:w-2/3 w-full relative">
            <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.id">
              <item-list-view :item="item">

                <!-- SLOT: ITEM META -->
                <template slot="item-meta">
                  <h6 class="item-name font-semibold mb-1">{{ item.title }}</h6>
                  <p class="text-sm mb-2 cursor-pointer">By <span
                    class="text-primary font-semibold">{{ getAuthor(item).value }}</span>
                  </p>
                  <p class="mt-4 font-bold text-sm">Number</p>
                  <vs-input-number min="1" max="10" :value="item.qty"
                                   @input="updateItemQuantity($event, index, item)" class="inline-flex"/>

                  <p class="font-medium text-grey mt-4">
                    Approximate delivery time:
                    3-4 Days
                  </p>
                  <p class="text-primary font-bold" v-if="getOrgPrice(item)">
                    CBS Member
                    {{ getPrice(item) | price }}
                  </p>
                  <p class="text-grey font-medium" v-if="getOrgPrice(item)">
                    Original Price :
                    {{ getOrgPrice(item) | price }}
                  </p>
                </template>

                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">

                  <!-- PRIMARY BUTTON: REMOVE -->
                  <div
                    class="item-view-primary-action-btn p-3 bg-danger text-white rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                    @click="removeItemFromCart(item)">
                    <feather-icon class="text-white" icon="XIcon" svgClasses="h-4 w-4"/>
                    <span class="text-sm font-semibold ltr:ml-2 rtl:mr-2 text-white">Remove from cart</span>
                  </div>
                </template>
              </item-list-view>
            </div>
          </div>

          <!-- RIGHT COL -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card color="primary" title="GET UP TO 15% DISCOUNT!" class="bg-primary-gradient text-white"
                     v-if="!isLogin">
              Sign up now as a CBS member & enjoy our royal discounts!
              <br>
              <div class="text-center mt-4">
                <router-link to="/auth/register">
                  <vs-button color="warning">
                    Join Cyrus Book Store
                  </vs-button>
                </router-link>

              </div>
            </vx-card>
            <vx-card>
              <!--<p class="text-grey mb-3">Purchase details</p>-->
              <!--<div class="flex justify-between">-->
              <!--<span class="font-semibold">Discount Coupon</span>-->
              <!--<span class="font-medium text-primary cursor-pointer"></span>-->
              <!--</div>-->

              <!--<vs-divider/>-->
              <p class="text-grey mb-3">Promo Code</p>
              <div class="flex items-end justify-between " id="coupon-wrapper">
                <div class="w-1/2">
                  <vs-input name="event-name" class="w-full" label-placeholder="Promo Code" v-model="coupon"
                            @keypress.enter="checkCoupon"></vs-input>
                </div>
                <span class="font-medium text-primary cursor-pointer" v-if="!hasPromoCode" @click="checkCoupon"
                      :disabled="loadingCoupon">Apply</span>
                <span class="font-medium text-danger cursor-pointer" v-else
                      @click="removePromoCode">Remove Promo Code</span>
              </div>
              <vs-divider/>
              <p class="font-semibold mb-3">Payment Details</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Sub Total</span>
                <div>
                  <span>{{ getTotal | price }}</span>
                </div>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Discount</span>
                <div class="text-success">
                  <span>{{ getDiscount() | price }}</span>

                </div>
              </div>
              <div class="flex justify-between mb-2" v-if="hasPromoCode">
                <span class="text-grey"> Promo Discount</span>
                <div class="text-success">
                  <span>{{ promoCodeDiscount | price }}</span>

                </div>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Shipping Cost</span>
                <div class="text-success">
                  <span>Depends On Address</span>
                </div>
              </div>
              <vs-divider/>

              <div class="flex justify-between font-semibold mb-3">
                <span>Total Sales</span>
                <div>
                  <span>{{ getTotalOrder | price }}</span>
                </div>
              </div>
              <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">Checkout</vs-button>
            </vx-card>
          </div>
        </div>

        <!-- IF NO ITEMS IN CART -->
        <vx-card v-else>
          <div class="flex flex-col items-center">
            <img src="@/assets/images/no-items.svg" style="width: 350px;max-width: 100%">
            <h3 class="text-center text-primary">You don't have any items in your cart.</h3>
            <vs-button class="mt-5" :href="home">Browse Shop</vs-button>
          </div>
        </vx-card>

      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Select address" icon="feather icon-home" class="mb-5">

        <div class="vx-row">

          <!-- LEFT COL: NEW ADDRESS -->
          <div class="vx-col  w-full" :class="{'lg:w-2/3':isLogin}">
            <vx-card :title="getCartAddressTitle"
                     subtitle="Note that the following address is you receive address" class="mb-base">

              <form data-vv-scope="add-new-address">
                <p>Purchased As</p>
                <div class="vx-row p-4">
                  <vs-radio v-model="type" vs-name="type" class="mr-3" vs-value="personal">Personal</vs-radio>
                  <vs-radio v-model="type" vs-name="type" vs-value="organization">Organization</vs-radio>
                </div>
                <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full">

                    <vs-input
                      v-validate="'required|alpha_spaces'"
                      data-vv-as="Name"
                      name="fullName"
                      label="Name"
                      v-model="fullName"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.fullName')"
                          class="text-danger">{{ errors.first('add-new-address.fullName') }}</span>

                  </div>
                  <div class="vx-col sm:w-1/2 w-full">

                    <vs-input
                      v-validate="validOrg"
                      data-vv-as="Organization"
                      name="organization"
                      label="Organization"
                      v-model="organization"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.organization')"
                          class="text-danger">{{ errors.first('add-new-address.organization') }}</span>

                  </div>

                  <div class="vx-col sm:w-1/2 w-full">

                    <vs-input
                      v-validate="'required|numeric'"
                      name="mobileNum"
                      data-vv-as="Phone number"
                      label="Phone number"
                      v-model="mobileNum"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.mobileNum')"
                          class="text-danger">{{ errors.first('add-new-address.mobileNum') }}</span>
                  </div>

                  <div class="vx-col sm:w-1/2 w-full">

                    <vs-input
                      v-validate="'required|email'"
                      name="email"
                      data-vv-as="Email"

                      label="Email"
                      v-model="email"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.email')"
                          class="text-danger">{{ errors.first('add-new-address.email') }}</span>
                  </div>

                </div>


                <div class="vx-row">


                  <div class="vx-col sm:w-1/2 w-full">

                    <vs-input
                      v-validate="'required|zippy'"
                      name="zip"
                      data-vv-as="Postal code"

                      label="Postal code"
                      v-model="zip"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.zip')"
                          class="text-danger">{{ errors.first('add-new-address.zip') }}</span>
                  </div>
                </div>
                <div class="vx-row">


                  <div class="vx-col sm:w-1/3 w-full">

                    <vs-select
                      v-validate="'required'"
                      name="country"
                      label="Country"
                      data-vv-as="Country"
                      v-model="country"
                      class="w-full mt-5">
                      <vs-select-item value="malaysia" text="Malaysia"  />
                    </vs-select>
                    <span v-show="errors.has('add-new-address.country')"
                          class="text-danger">Please enter your country</span>
                  </div>

                  <div class="vx-col sm:w-1/3 w-full">

                    <vs-input
                      v-validate="'required'"
                      name="city"
                      label="City"
                      data-vv-as="City"

                      v-model="city"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.city')"
                          class="text-danger">{{ errors.first('add-new-address.city') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">

                    <vs-input
                      v-validate="'required'"
                      name="state"
                      label="State"
                      data-vv-as="State"

                      v-model="state"
                      class="w-full mt-5"/>
                    <span v-show="errors.has('add-new-address.state')"
                          class="text-danger">{{ errors.first('add-new-address.state') }}</span>
                  </div>


                </div>
                <div>
                  <vs-textarea
                    v-validate="'required'"
                    name="address"
                    label="Full Address"
                    data-vv-as="Full Address"

                    v-model="address"
                    class="w-full mt-5"/>
                  <span v-show="errors.has('add-new-address.address')"
                        class="text-danger">{{ errors.first('add-new-address.address') }}</span>
                </div>
                <vs-button class="mt-6 ml-auto flex" @click.prevent="submitNewAddressForm">Save and
                  confirm address
                </vs-button>
              </form>
            </vx-card>
          </div>

          <!-- RIGHT COL: CONTINUE WITH SAVED ADDRESS -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card :title="item.company" v-for="(item,index) in addresses" :key="index">
              <div>
                <p class="my-4">{{ item.province }} {{ item.city }}</p>
                <p class="my-4">{{ item.address }}</p>
                <p class="my-4"><span>Postal code : </span>{{ item.zip }}</p>
                <p>Phone : {{ item.phone }}</p>
              </div>

              <vs-divider/>

              <vs-button class="w-full" @click="selectAddress(item)">
                Send to this address
              </vs-button>
            </vx-card>
          </div>

        </div>
      </tab-content>

      <!-- tab 3 content -->
      <tab-content title="Pay" icon="feather icon-credit-card" class="mb-5">

        <div class="vx-row">

          <!-- LEFT COL: PAYMENT OPTIONS -->
          <div class="vx-col lg:w-2/3 w-full">
            <vx-card>
              <!--<p class="text-grey mb-3">Purchase details</p>-->
              <!--<div class="flex justify-between">-->
              <!--<span class="font-semibold">Discount Coupon</span>-->
              <!--<span class="font-medium text-primary cursor-pointer"></span>-->
              <!--</div>-->

              <!--<vs-divider/>-->

              <p class="font-semibold mb-3">Payment Details</p>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Sub Total</span>
                <div>
                  <span>{{ getTotal | price }}</span>
                </div>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Total Items</span>
                <span class="font-semibold">
                                    {{ cartItems.length }}
                                </span>

              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Discount</span>
                <div class="text-success">
                  <span>{{ getDiscount() | price }}</span>

                </div>
              </div>
              <div class="flex justify-between mb-2" v-if="hasPromoCode">
                <span class="text-grey"> Promo Discount(s)</span>
                <div class="text-success">
                  <span>{{ promoCodeDiscount | price }}</span>

                </div>
              </div>
              <div class="flex justify-between mb-2">
                <span class="text-grey">Shipping Cost</span>
                <span class="text-success">{{ shippingCost | price }}</span>
              </div>

              <vs-divider/>

              <div class="flex justify-between font-semibold mb-3">
                <span>Total Sales</span>
                <div>
                  <span>{{ getTotalOrder | price }}</span>
                </div>
              </div>
              <div style="width: 250px">
                <vs-button class="w-full" @click="payment">Proceed with payment</vs-button>
              </div>

            </vx-card>
            <div v-if="forceUp"></div>
          </div>

          <!-- RIGHT COL: PRICE -->
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card :title="selectedAddress.company">
              <div>
                <p class="my-4">{{ selectedAddress.province }} {{ selectedAddress.city }}</p>
                <p class="my-4">{{ selectedAddress.address }}</p>
                <p class="my-4"><span>Postal code : </span>{{ selectedAddress.zip }}</p>
                <p>Phone : {{ selectedAddress.phone }}</p>
              </div>
            </vx-card>
          </div>
        </div>
        <form method="post" :action="pd.action" ref="formEghl">
          <input type="hidden" v-for="(item,key) in pd.data" :key="key" :name="key" :value="item">
        </form>
      </tab-content>

    </form-wizard>
  </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import _ from 'lodash';
import zippy from '@/plugins/validate';
import themeConfig from '@/../themeConfig.js';

const ItemListView = () => import('./apps/eCommerce/components/ItemListView.vue')

export default {
  data() {
    return {

      // TAB 2
      fullName: "",
      mobileNum: "",
      pincode: "",
      houseNum: "",
      loadingCoupon: false,
      zip: "",
      organization: "",
      address: "",
      country: "malaysia",
      coupon: undefined,
      area: "",
      email: "",
      landmark: "",
      type: "personal",
      city: "",
      state: "",
      addressType: 1,
      pd: {
        data: []
      },
      addressTypeOptions: [
        {text: 'Home', value: 1},
        {text: 'Office', value: 2},
      ],

      // TAB 3
      paymentMethod: "debit-card",
      cvv: '',
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();

    },
    getCartAddressTitle() {
      return this.isLogin ? "Send new address" : 'Send Address'
    },
    forceUp() {
      this.$forceUpdate();
      return this.$store.state.eCommerce.forceUp;
    },
    isLogin() {
      return localStorage.getItem('accessToken') != undefined;
    },
    validOrg() {
      return this.type != 'personal' ? 'required|alpha_spaces' : '';
    },
    shippingCost() {
      if (this.$store.state.eCommerce.shippingCost === undefined) {
        return 'Depended on Address'
      } else if (this.$store.state.eCommerce.shippingCost === -1) {
        return 'Invalid Postal Code'
      }
      return this.$store.state.eCommerce.shippingCost;
    },
    home() {
      return themeConfig.domain + '/shop';
    },
    addresses() {
      console.log(this.$store.state.address.list,'this.$store.state.address.list')
      return this.$store.state.address.list;
    },
    hasPromoCode() {
      return this.$store.state.eCommerce.hasCoupon;
    },
    isInWishList() {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    selectedAddress() {
      return this.$store.state.eCommerce.address || {};
    },
    getTotal() {
      let allPrice = _.map(this.$store.state.eCommerce.cartItems, (item) => {
        return _.get(item, 'variants.0.original_price', 0) * (item.qty || 1);
      });
      this.$store.commit('eCommerce/SET_TOTAL', _.sum(allPrice));
      // if (this.isLogin) {
      //   let dis = parseFloat(this.getDiscount || 0);
      //   let price = parseFloat(_.sum(allPrice));
      //   return (price + dis).toFixed(2);
      // } else {
      //   return _.sum(allPrice);
      // }
      return _.sum(allPrice)
    },
    getTotalOrder() {
      let s = parseFloat(this.$store.state.eCommerce.shippingCost || 0);
      let total = parseFloat(this.getTotal);
      let dis = parseFloat(this.getDiscount());
      let proDis = parseFloat(this.promoCodeDiscount);
      return (total + s) - dis - proDis;
    },


    promoCodeDiscount() {
      let a = this.$store.state.eCommerce.hasCoupon;
      let allPrice = _.map(this.$store.state.eCommerce.cartItems, (item) => {
        item.qty;
        return item.promoDiscount || 0;
      });
      this.$store.commit('eCommerce/SET_PRO_DISCOUNT', _.sum(allPrice));

      return _.sum(allPrice).toFixed(2);
    }
  },
  methods: {
    getDiscount() {
      let allPrice = _.map(this.$store.state.eCommerce.cartItems, (item) => {
        item.qty;
        item.promoDiscount;
        if (!item.coupon) {
          return (this.getOrgPrice(item) - this.getPrice(item)) * (item.qty || 1);
        } else {
          return 0;
        }
      });
      this.$store.commit('eCommerce/SET_DISCOUNT', _.sum(allPrice));

      return _.sum(allPrice).toFixed(2);
    },
    async removePromoCode() {
      this.coupon = undefined;
      await this.$store.dispatch('eCommerce/removeCoupon', this.coupon);
    },
    __getDiscount(item) {
      let price = this.getPrice(item);
      if (item.coupon) {
        switch (item.couponType) {
          case 1:
            price = ((item.coupon / 100) * price) * item.qty;
            break;
          case 2:
            price = price * item.qty;
            break;
          default:
            price = 0;
        }
      } else {
        price = 0;
      }
      return price;
    },
    async checkCoupon() {
      try {
        if (!this.coupon) return;
        this.loadingCoupon = true;
        this.$vs.loading({
          container: '#coupon-wrapper',
          scale: 0.6
        });
        const data = await this.$store.dispatch('eCommerce/checkCoupon', this.coupon);
        this.$vs.notify({
          color: 'success',
          text: 'You have successfully redeemed the promotional discount!\n',
        });
      } catch (e) {
        this.$vs.notify({
          color: 'danger',
          text: 'The promotion code entered is invalid',
        });
      } finally {
        this.loadingCoupon = false;
        this.$forceUpdate();
        this.$vs.loading.close('#coupon-wrapper > .con-vs-loading');
      }
    },
    payment() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm`,
        text: 'Are you sure you want to proceed with this order?',
        accept: () => {
          this.$vs.loading();
          this.$store.dispatch('eCommerce/setOrder', {proDis: this.promoCodeDiscount}).then((data) => {
            this.pd = data.tr;
            setTimeout(() => {
              this.$store.dispatch('eCommerce/flush');
              this.$refs.formEghl.submit();
              // this.$vs.loading.close();
            }, 1000);
            // window.location.href = data.href;
          }).catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              type: 'confirm',
              color: 'danger',
              text: 'Error registering order. Sorry, your order to create failed.',
              accept: () => {

              }
            });
          });
        }
      });
    },
    // TAB 1
    removeItemFromCart(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to remove the item from the cart?',
        accept: () => {
          this.$store.dispatch('eCommerce/toggleItemInCart', item)
        }
      });
    },
    selectAddress(item) {
      if (!zippy(item.zip)) {
        this.$vs.notify({
          type: 'confirm',
          color: 'danger',
          text: 'Postal Code Invalid!',
          accept: () => {

          }
        });
        return;
      }
      this.$store.commit('eCommerce/SET_ADDRESS', item);
      this.$refs.checkoutWizard.nextTab();
    },
    wishListButtonClicked(item) {
      // Toggle in Wish List
      if (this.isInWishList(item.objectID)) this.$router.push('/apps/eCommerce/wish-list').catch(() => {
      })
      else {
        this.toggleItemInWishList(item)
        this.removeItemFromCart(item)
      }
    },
    toggleItemInWishList(item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    updateItemQuantity(event, index, item) {
      const itemIndex = Math.abs(index + 1 - this.cartItems.length)
      this.$store.dispatch("eCommerce/updateItemQuantity", {
        qty: event,
        index: itemIndex,
        oprice: _.get(item, 'variants.0.original_price', 0),
        price: this.getPrice(item)
      })
    },

    getVendor(item) {
      return _.get(item, 'vendor.title', 'Unknown')
    },
    getAuthor(item) {
      return _.find(item.attr, (attr) => attr.title == 'Author') || {}
    },
    getImg(item) {
      return _.get(item, 'image.src')
    },
    getPrice(item) {
      if (this.isLogin) {
        return _.get(item, 'variants.0.price', 0);
      }
      return _.get(item, 'variants.0.original_price', 0);
    },
    getPromoDiscountPrice(item) {
      let price = this.getPrice(item);
      if (item.coupon) {
        switch (item.couponType) {
          case 1:
            price = ((item.coupon / 100) * price);
            break;
          case 2:
            price = item.coupon;
            break;
        }
      }
      return price * item.qty;
    },
    getOrgPrice(item) {
      return _.get(item, 'variants.0.original_price', false);
    },

    // TAB 2
    submitNewAddressForm() {
      return new Promise(() => {
        this.$validator.validateAll('add-new-address').then(result => {
          if (result) {
            // if form have no errors
            this.$store.commit('eCommerce/SET_ADDRESS', {
              city: this.city,
              province: this.state,
              phone: this.mobileNum,
              email: this.email,
              name: this.fullName,
              type: this.type,
              company: this.organization,
              address: this.address,
              zip: this.zip
            });
            this.$refs.checkoutWizard.nextTab()
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Please enter valid details',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    },


    aa() {


    },
    // TAB 3
    makePayment() {
      return new Promise(() => {
        this.$validator.validateAll('cvv-form').then(result => {
          if (result) {
            // if form have no errors
            this.$vs.notify({
              title: 'Success',
              text: 'Payment received successfully',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Please enter valid details',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    }
  },
  components: {
    ItemListView,
    FormWizard,
    TabContent
  },
  mounted() {
    // this.$store.dispatch('address/fetch');
  }
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
  }

  .item-name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }

  .vue-form-wizard {
    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
    }
  }
}
</style>
